/*
 * /psychological-context (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import { Container, Page, PageHeader } from "@psychology/react-ui"
import { isAdmin } from "@psychology/utils"
import { useState } from "react"
import { ContextDataDumpDialog } from "../features/psychological-context/components/context-data-dump-dialog"
import { ContextDataDumpList } from "../features/psychological-context/components/context-data-dump-list"
import { PsychologicalContextForm } from "../features/psychological-context/components/psychological-context-form"
import { trpc } from "../trpc"
import { authPageLoader } from "../utils/auth.utils"

export const Route = createFileRoute("/psychological-context")({
	component: PsychologicalContextPage,
	loader: authPageLoader,
})

function PsychologicalContextPage() {
	const { user } = Route.useLoaderData()
	const admin = isAdmin(user)
	const [scrollToDumpId, setScrollToDumpId] = useState<string | null>(null)

	const { data, isLoading } = trpc.psychologicalContext.getByFilter.useQuery({
		where: { userId: user.id },
	})

	return (
		<Page centerVertical={false}>
			<Container width={"xxxl"} padding={"lg"} gap={"lg"}>
				<div className={"flex items-center justify-between"}>
					<PageHeader title={"Psychological Context"} />
					<ContextDataDumpDialog
						userId={user.id}
						onCreated={(dump) => setScrollToDumpId(dump.id)}
					/>
				</div>

				{isLoading ? (
					<div className={"py-8 text-center text-muted-foreground"}>
						{"Loading..."}
					</div>
				) : data || admin ? (
					<PsychologicalContextForm
						psychologicalContext={data ?? undefined}
						userId={user.id}
						isAdmin={admin}
					/>
				) : (
					<div className={"py-8 text-center text-muted-foreground"}>
						<p>{"No psychological context available yet."}</p>
						<p className={"mt-2 text-sm"}>
							{
								"Your psychological context will be generated based on your journal entries and interactions."
							}
						</p>
					</div>
				)}

				<ContextDataDumpList
					userId={user.id}
					scrollToId={scrollToDumpId}
					onScrolled={() => setScrollToDumpId(null)}
				/>
			</Container>
		</Page>
	)
}
